export class ObjectiveOverviewHeaderField {
    constructor(readonly caption: string) {
    }
}
